import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { fetchNewsletters } from "../../api/newsletterApi";
import { readUserFromStorage } from "../../utils/planningAccess";
import { userCanManageNewsletter } from "../../utils/newsletterAccess";
import { formatIssueRange, usePingfloScoreboardFont } from "./newsletterFormat";
import "./../../pages/newsletter/PingfloNewsletterPage.css";

export function NewsletterHomeCard() {
  const { t, i18n } = useTranslation();
  const [issue, setIssue] = useState(null);
  const [canManageApi, setCanManageApi] = useState(null);
  const [ready, setReady] = useState(false);
  usePingfloScoreboardFont();

  useEffect(() => {
    let cancelled = false;
    fetchNewsletters()
      .then((data) => {
        if (cancelled) return;
        setIssue(data?.issues?.[0] || null);
        if (typeof data?.can_manage === "boolean") {
          setCanManageApi(data.can_manage);
        } else {
          setCanManageApi(null);
        }
      })
      .catch(() => {
        if (!cancelled) setIssue(null);
      })
      .finally(() => {
        if (!cancelled) setReady(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready) return null;
  const staff =
    userCanManageNewsletter(readUserFromStorage()) && canManageApi !== false;
  // Published issues are visible to the club; setup CTA is admin-only.
  if (!issue && !staff) return null;

  const board = issue?.scoreboard || {};
  const range = formatIssueRange(issue?.start_date, issue?.end_date, i18n.language);
  const href = issue ? `/newsletter/${issue.issue_id}` : "/newsletter";

  return (
    <Link className="pingflo-home" to={href}>
      <p className="pingflo-mark">Pingflo</p>
      <p className="pingflo-home-range">{range || t("newsletterSetup", "Cycle")}</p>
      {issue ? (
        <ol>
          <li>
            <strong>{board.sessions || 0}</strong>
            <span>{t("newsletterScoreSessions", "Sessions")}</span>
          </li>
          <li>
            <strong>{board.players || 0}</strong>
            <span>{t("newsletterScorePlayers", "Players")}</span>
          </li>
          <li>
            <strong>{board.wins || 0}</strong>
            <span>{t("newsletterScoreWins", "Wins")}</span>
          </li>
          <li>
            <strong>{board.best_rally || 0}</strong>
            <span>{t("newsletterScoreRally", "Best rally")}</span>
          </li>
        </ol>
      ) : (
        <p>{t("newsletterSetupPrompt", "Set the cycle and the groups this issue follows")}</p>
      )}
    </Link>
  );
}
